export default class OnBoardingRequestModel {
    IsCountry: boolean = false;

    IsPrimaryRole: boolean = false;

    IsCompanySize: boolean = false;

    IsRegionOfOperation: boolean = false;

    IsBusinessCategory: boolean = false;

    IsIntegrationType: boolean = false;
    
    IsLanguage: boolean = false;

    IsStates: boolean = false;
    
    CountryCode: string = "US";
}